// check if browser
export const isBrowser = typeof window !== "undefined";

// check if online
export const isOnline = typeof window !== "undefined" && window.navigator.onLine;
